export const PACKAGES = [
  {
    id: "deal_closer",
    name: "The Deal Closer",
    price: 500,
    term: "Focus: selling after rehab",
    tagline: "Selling after rehab",
    description: "For investors who need help closing deals and selling the flip.",
    features: [
      "Module 5: Marketing & Selling",
      "Manufactured home bill of sale template",
      "Community & networking access",
    ],
    oneOnOne: false,
    fieldTraining: false,
  },
  {
    id: "full_flip_formula",
    name: "Full Flip Formula",
    price: 1200,
    term: "6-week core program",
    tagline: "Full program, personal support",
    description: "The complete step-by-step path to your first flip, with two private calls and the community behind you.",
    features: [
      "Full 6-week module access",
      "2× 30-min 1-on-1 calls",
      "Pre/post inspection checklist + bill of sale template",
      "Community & networking access",
    ],
    oneOnOne: true,
    fieldTraining: false,
  },
  {
    id: "inner_circle",
    name: "Inner Circle",
    price: 1600,
    term: "Full support for scaling",
    tagline: "The highest-touch package",
    description: "The full curriculum, private calls, both templates, and contractor guidance — everything you need to scale.",
    features: [
      "Full 6-week module access",
      "2× 30-min 1-on-1 calls",
      "Both templates (inspection checklist + bill of sale)",
      "Help finding recommended contractors",
      "Community & networking access",
    ],
    oneOnOne: true,
    fieldTraining: false,
  },
];
